export default __webpack_public_path__ + "static/media/Aphrodite_Desktop.057b8ca7.mp4";